import React from "react";
import DarkPopover from "components/shared/DarkPopover";

function SellPageCardVariationBenefit({ benefit }) {
  return (
    <li className="access-benefits__list-item">
      <div className="access-benefits__list-item__check">
        <i className="lc-icon lc-icon-checkmark-thick lc-icon-xs" />
        <span
          className="body-2 supported-text"
          dangerouslySetInnerHTML={{ __html: benefit.text }}
        />
      </div>
      {!benefit.skipPopover && (
        <DarkPopover
          key={benefit.text}
          title={benefit.title}
          subcopy={benefit.subcopy}
          imageSrc={benefit.img}
          imageAlt={benefit.text}
          visible={false}
          active
        />
      )}
    </li>
  );
}

function Benefit({ benefit }) {
  return (
    <li className="access-benefits__list-item">
      <div className="access-benefits__list-item__check">
        <i className="lc-icon lc-icon-checkmark-thick lc-icon-xs" />
        <span
          className="subtitle-1"
          dangerouslySetInnerHTML={{ __html: benefit.text }}
        />
      </div>
      {!benefit.skipPopover && (
        <DarkPopover
          title={benefit.title}
          subcopy={benefit.subcopy}
          imageSrc={benefit.img}
          imageAlt={benefit.text}
          visible={false}
          active
        />
      )}
    </li>
  );
}

function AccessBenefits({ benefits, sellPageCardVariation = false }) {
  return (
    <div className="access-benefits__container">
      <div className="access-benefits__list-container">
        {benefits.map((benefit) =>
          sellPageCardVariation ? (
            <SellPageCardVariationBenefit
              key={benefit.text}
              benefit={benefit}
            />
          ) : (
            <Benefit key={benefit.text} benefit={benefit} />
          )
        )}
      </div>
    </div>
  );
}

export default AccessBenefits;
